const customCssMixins = {
  async mounted() {
    if (this.$customCssProject.includes(this.$route.params.projectSlug)) {
      await import('@/custom-css/' + this.$route.params.projectSlug + '.css')
    }
  },
}

export default customCssMixins
